/**
 * @internal
 */
import styled from '@emotion/styled';
import React, { createContext, useContext } from 'react';
import LayoutIndexes from '@polestar/component-warehouse-react/tokens/layout-indexes/LayoutIndexes';
import useCallbackRef from '@polestar/component-warehouse-react/hooks/useCallbackRef';
import { useDirection } from '@polestar/component-warehouse-react/contexts/direction';
export const PortalContext = createContext({
    container: null,
    focusContainer: null,
});
export const usePortal = () => useContext(PortalContext);
const PortalProvider = ({ children, container, className }) => {
    const [portalRef, innerContainer] = useCallbackRef();
    const [focusPortalRef, focusContainer] = useCallbackRef();
    const { direction } = useDirection();
    // TODO: create focus portal with own index 120 to live always above portal (100) & megamenu (101)
    return (React.createElement(PortalContext.Provider, { value: { container: container || innerContainer, focusContainer } },
        children,
        !container && (React.createElement(PortalContainer, { className: className, "data-type": "portal", dir: direction, ref: portalRef })),
        React.createElement(FocusPortalContainer, { className: className, "data-type": "focus-portal", dir: direction, ref: focusPortalRef })));
};
export default PortalProvider;
const PortalContainer = styled.div `
  position: absolute;
  height: 0;
  width: 0;
  inset-inline-start: 0;
  inset-block-start: 0;
  z-index: ${LayoutIndexes.popover};

  > div {
    position: absolute;
    z-index: ${LayoutIndexes.modal};
    inset-block-start: 0;
    inset-inline-end: 0;
    inset-block-end: 0;
    inset-inline-start: 0;
    /**
    * Prevent inert-polyfill from ignoring events on inert
    */
    pointer-events: auto;
  }
`;
const FocusPortalContainer = styled(PortalContainer) `
  z-index: ${LayoutIndexes.popoverOutsidePortal + 1};
`;
